import { useState } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import { useProfile } from '../hooks/useProfile';

export default function SettingsPage() {
  const user = useAuthStore((s) => s.user);
  const { updateUsername } = useProfile();

  const [username, setUsername] = useState(user?.username ?? '');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSave(e: React.FormEvent) {
    e.preventDefault();
    if (!username.trim() || username === user?.username) return;
    setSaving(true);
    setError(null);
    setSaved(false);
    try {
      await updateUsername(username.trim());
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to save');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="settings-page">
      <h1 className="page-title">settings</h1>

      <section className="settings-section">
        <h2 className="profile-section-title">account</h2>

        <form className="settings-form" onSubmit={(e) => void handleSave(e)}>
          <div className="form-field">
            <label className="form-label" htmlFor="settings-email">email</label>
            <input
              id="settings-email"
              className="form-input"
              type="email"
              value={user?.email ?? ''}
              disabled
              aria-describedby="email-note"
            />
            <span id="email-note" className="settings-field-note">
              email cannot be changed
            </span>
          </div>

          <div className="form-field">
            <label className="form-label" htmlFor="settings-username">username</label>
            <input
              id="settings-username"
              className="form-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              minLength={3}
              maxLength={30}
              autoComplete="username"
            />
          </div>

          {error && <p className="form-error">{error}</p>}

          <div className="settings-actions">
            <button
              type="submit"
              className="btn btn--primary"
              disabled={saving || !username.trim() || username === user?.username}
            >
              {saving ? 'saving…' : saved ? 'saved' : 'save changes'}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}
